// @flow
import type {Element} from 'react';
import React, {Component} from 'react';
import {View} from 'react-native';
import type {Contracts as ContractList} from 'digicel-kaizen-library';
import ContractsItemsPickerButton from './components/ContractsItemsPickerButton';
import * as Navigation from '../../lib/navigation.js';

type StateProps = {
  contracts: ContractList,
};

type Props = StateProps;

class Contracts extends Component<Props> {
  onContractLinePress = (subscriptionSerialNumber: string) => () => {
    Navigation.navigate('checkDocuments', {
      subscriptionSerialNumber: subscriptionSerialNumber,
    });
  };

  renderContracts = () => {
    const {contracts} = this.props;

    if (contracts !== null || contracts !== undefined) {
      return Object.keys(contracts).map<Element<*>>(key => (
        <ContractsItemsPickerButton
          key={key}
          onPress={this.onContractLinePress(key)}
          label={key}
        />
      ));
    }
  };

  render() {
    return <View>{this.renderContracts()}</View>;
  }
}

export default Contracts;
